import { Component, h } from 'preact';

import getStore from '../../../store';
import * as InquiriesActions from '../../../reducers/inquiries/inquiries.actions';

interface InqStageTransitionContentProps {
  targetName: string;
  headingText?: string;
  customBodyText?: string;

  onProceed: () => void;
  onClose: () => void;
};

export class InqStageTransitionContent extends Component<InqStageTransitionContentProps> {
  getTransitionBodyText(props: InqStageTransitionContentProps) {
    if (props.customBodyText) {
      return (
        <p className="hi-inqstgtransition__text">{ props.customBodyText }</p>
      );
    } else {
      return (
        <p className="hi-inqstgtransition__text">
          Inquiry will be moved under { props.targetName } stage.
        </p>
      );
    }
  } 

  onClose() {
    getStore().dispatch(InquiriesActions.loadAllStages());
    this.props.onClose();
  }

  render(props: InqStageTransitionContentProps) {
    return (
      <div className="hi-inqstgtransition">
        <h3 className="hi-inqstgtransition__heading">{ props.headingText || 'Successful Upload' }</h3>

        { this.getTransitionBodyText(props) }

        <div className="hi-inqstgtransition__buttons">
          <button className="btn btn-secondary" onClick={ props.onProceed }>Proceed to { props.targetName }</button>
          <button className="btn btn-outline-dark" onClick={ props.onClose }>Back</button>
        </div>
      </div>
    )
  }
}
